import annaPic from "@/public/images/artists/anna.png";
import { Artist } from "@/types/types";

export const anna = {
  id: "208",
  name: "Anna",
  image: annaPic,
  description: `Anna's voice is bright and ethereal, with a sparkling high pitch and a playful, magical vibe. Its effortless lightness and soaring notes make it perfect for uplifting melodies.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fanna-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: [
        "Kids",
        "Ballads",
        "Pop",
        "Theatrical",
        "Ethereal",
        "Unprocessed",
      ],
      secondary: ["Teen"],
    },
    pitchRange: {
      categories: {
        low: "High",
        high: "Very high",
      },
      specific: {
        low: 54,
        high: 76,
      },
      sweetSpot: 65,
    },
  },
} as const satisfies Artist;
